import { postAddVenues } from '@/services/venue.service';
import { updateProcessStatus } from '../MultiFlightMap/multiFlightMap.resources';

import type { ProcessUpload } from 'sonata-static-storage/lib/schemas/processUpload/processUpload.schema';
import type { Venue } from 'sonata-static-storage/lib/schemas/venue/venue.schema';

export async function handleItemsCallback(
  items: Venue[],
  processId: string,
  userId: string,
  updateProcessStatusToken: Record<string, any>,
  postNewVenuesToken: Record<string, any>,
  processUpload?: ProcessUpload['uploadProcess']
): Promise<Venue[]> {
  const normalizedItems = items.map(item => ({
    address: item.address,
    country: item.country,
    deleted: false,
    geoDataId: item.geoDataId,
    geoDataSourceId: item.geoDataSourceId,
    groups: item.groups,
    latlng: item.latlng,
    mooh: item.mooh,
    name: item.name,
    sourceType: 'myVenues',
    type: item.type,
    user: userId
  }));
  const addVenuesPromise: Promise<Venue[]> =
    processUpload === 'attributionPOIUpload'
      ? Promise.resolve(normalizedItems as Venue[])
      : postAddVenues(normalizedItems as Array<Venue>, postNewVenuesToken);

  const [newVenues] = await Promise.all([
    addVenuesPromise,
    updateProcessStatus(processId, 'accept', updateProcessStatusToken)
  ]);
  return newVenues;
}
